// extracted by mini-css-extract-plugin
export default {"Iframe_asset":"Iframe_asset_GBCsn"};